import { Link, useNavigate } from 'react-router-dom';
import { useAccount, useStore } from '../../../store';
import { Icon } from '../../display';
import { showMessageBox } from '../../modals';
import classes from './AccountBlock.module.scss';

export default function AccountBlock() {
  const { authStore } = useStore();
  const account = useAccount({ throwIfEmpty: false });
  const navigate = useNavigate();

  async function onSignOut() {
    const buttonId = await showMessageBox({
      title: 'Sign out',
      content: 'Are you sure you want to sign out?',
      buttons: [
        { id: 'signOut', title: 'Sign Out', icon: 'sign-out-alt' },
        { id: 'cancel', title: 'Cancel' },
      ],
    });

    if (buttonId === 'signOut') {
      await authStore.signOut();
      navigate('/', { replace: true });
    }
  }

  return (
    <div className={classes.root}>
      <Link className={classes.avatar} to="/account">
        <Icon icon="user" size="medium" sx={{ mr: 0 }} />
      </Link>
      <div className={classes.userActions}>
        <Link className={classes.email} to="/account">
          {account?.email}
        </Link>
        <button className={classes.logout} onClick={onSignOut} type="button">
          <Icon icon="sign-out-alt" />
          sign out
        </button>
      </div>
    </div>
  );
}
